import React from "react";
import {
  getEmailConfig,
  updateEmailConfig
} from "adminApi/EmailSettingApi/EmaillSetting";
import { validateForm } from "utils/validation";
import { MailSettingRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import EmailConfigForm from "./Componate/EmailConfigForm";
import fields from "../json/EmailSettingFields.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchFormDataById from "Hooks/useFetchFormDataById";
import { useRoleVerify } from "Common/RoleVerify";

/**
 * EmailConfig Component
 * Manages SMTP and general email server configurations.
 */
const EmailConfig = () => {
  // Check user edit permissions
  const canUpdate = useRoleVerify("", ["can_edit"]);
  const { EmailConfigFormData } = fields;

  // Initialize form state
  const initialValues = EmailConfigFormData.reduce(
    (acc, field) => ({ ...acc, [field.name]: "" }),
    {}
  );

  const { values, errors, handleChange, setValues, setErrors } = useFormChange(
    initialValues,
    MailSettingRules
  );

  // Fetch existing SMTP configuration (assuming ID 1 for global config)
  const { loading: loadingFetch } = useFetchFormDataById(
    '1',
    EmailConfigFormData,
    getEmailConfig,
    setValues
  );

  // Hook for handling configuration updates
  const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
    async (formValues) => {
      // Production refinement: Sending clean JSON object instead of FormData
      // Ensure email_config_id is included for the backup check (it should already be in values)
      return await updateEmailConfig({ data: formValues });
    },
    (vals) => {
      // Perform frontend validation
      const validationErrors = validateForm(vals, MailSettingRules);
      setErrors(validationErrors);
      return validationErrors;
    },
    () => {
      // Optional success callback
    },
    "Email configuration updated successfully!"
  );

  return (
    <>
      {/* Show spinner during data fetch or submission */}
      {(loadingFetch || loadingSubmit) && <Spinner isSpinner={true} />}

      <EmailConfigForm
        fields={EmailConfigFormData}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loadingSubmit}
        title="SMTP Server Configuration"
        canUpdate={canUpdate}
      />
    </>
  );
};

export default EmailConfig;
